module.exports = __webpack_public_path__ + "static/media/nature-business-m.900c829b.webp";